import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Signal, WritableSignal, effect, numberAttribute, signal } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { PageComponent } from 'src/app/layout/pages/page/page.component';
import { CardComponent } from 'src/app/shared/components/cards/card/card.component';
import { EditableCardComponent } from 'src/app/shared/components/cards/editable-card/editable-card.component';
import { TextFieldComponent } from 'src/app/shared/components/fields/text-field/text-field.component';
import { ControlliService } from '../controlli.service';
import { PrelievoFormComponent } from '../components/prelievo-form/prelievo-form.component';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { PageDetailComponent } from 'src/app/layout/pages/page-detail/page-detail.component';
import {PageDetailComponentList} from 'src/app/layout/pages/page-detail-list/page-detail-list.component';
import {IControlliDettaglio, UpdateValoreControllo}  from "../models/prelievo-dettaglio.model";
import { Observable, Observer } from 'rxjs';
import { ControlloSingoloService } from '../controllo-singolo.service';
import { MatIconModule } from '@angular/material/icon';
import { TableComponent } from "../../../shared/components/table/table.component";
import { ITableColumn } from 'src/app/core/models/table.model';
import { PARAMETRI_ALERT_COLUMNS } from '../prelievo.config';
import { IParametri, IParametriAlert } from '../models/parametri-alert';
import { PARAMETRI_ALERT_COLUMNS_DETTAGLIO } from '../dettaglio.config';
import { InputNumberComponent } from "../../../shared/components/inputs/input-number/input-number.component";
import { SharedModule } from "../../../shared/shared.module";
import { InputTextComponent } from "../../../shared/components/inputs/input-text/input-text.component";
import { PrelievoService } from '../prelievo.service';
import { DialogService } from 'src/app/core/services/dialog.service';
import { MyDialogComponent } from '../../punti-campionamento/components/my-dialog/my-dialog.component';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { IAnalisiModify, IControlloModify, IPrelievoModify } from '../models/dati-controllo.model';
import { InputDatetimeComponent } from "../../../shared/components/inputs/input-datetime/input-datetime.component";
import { ControlloSingoloUpdateService } from '../controllo-singolo-update.service';
import { InputToggleComponent } from "../../../shared/components/inputs/input-toggle/input-toggle.component";
import { MyDialogComponentInsertParametri } from '../components/my-dialog/my-dialog-insert-parametri.component';
@Component({
    selector: 'app-dettaglio-page',
    standalone: true,
    templateUrl: './dettaglio-page.component.html',
    styleUrl: './dettaglio-page.component.css',
    imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDividerModule,
    MatSelect,
    MatSelectModule,
    PageComponent,
    InputDatetimeComponent,
    PageDetailComponent,
    PageDetailComponentList,
    CardComponent,
    EditableCardComponent,
    TextFieldComponent,
    PrelievoFormComponent,
    MatIconModule,
    TableComponent,
    InputNumberComponent,
    SharedModule,
    InputToggleComponent
]  

})

export class DettaglioPageComponent {
  @Input() id:string='0';
  form: FormGroup;
  formUpdate:FormGroup;
  formGeneric:FormGroup;
  columnsParametriAlert: ITableColumn[] = PARAMETRI_ALERT_COLUMNS_DETTAGLIO;
  model: WritableSignal<any | undefined> = signal(undefined);
  modelTable:WritableSignal<IParametriAlert[]>=signal([]);
  step:number=0
  item:any;
  errorMessage: string[] = [''];
  reload: EventEmitter<any> = new EventEmitter<any>();
    statusDefaultIcon: { [key: string]: string } = {
    'ok': 'done',
    'warning': 'warning',
    'alert': 'error'
  }
  
    statusDefaultTextColor: { [key: string]: string } = {
    'ok': 'text-green-400',
    'warning': 'text-yellow-400',
    'alert': 'text-red-400'
  }
  constructor(
    private readonly fb: FormBuilder,
    public readonly service: ControlloSingoloService,
    public readonly serviceUpdate: ControlloSingoloUpdateService,
    public readonly servicePrelievo : PrelievoService,
    private dialogService: DialogService,
    private cdr : ChangeDetectorRef,
    
  ) {
    this.form= this.fb.group<IControlliDettaglio>(<IControlliDettaglio>{});
    this.formUpdate= this.fb.group({
        id: this.fb.control(0),
        parametroId: this.fb.control(0),
        valoreArrotondato: this.fb.control(''),
        valoreRapportoProva: this.fb.control(''),
        incertezza: this.fb.control(''),
        metodo: this.fb.control(''),
        valoreLfs: this.fb.control(''),
        valoreLoq: this.fb.control(''),
        loq: this.fb.control(''),
        lfs: this.fb.control('')
      });
      this.formGeneric= this.fb.group({});
  }

  ngOnInit() {
    this.id = this.isURLEncoded(this.id) ? decodeURIComponent(this.id.toString()) : this.id
    this.form.valueChanges.subscribe(value=>{
      this.modelTable.set(this.model().dati)
    })

    this.formGeneric.valueChanges.subscribe(value => this.checkFormValidity());
  }

  get prelievo(): FormArray {
    return (this.form.get('prelievo') as FormGroup).get('items') as FormArray;
  }
  checkDataRow(dati:any){
    if(dati){
      this.formUpdate.controls['id'].setValue( this.id );
      this.formUpdate.controls['parametroId'].setValue(dati?.parametro?.id);
      this.formUpdate.controls['valoreRapportoProva'].setValue(dati?.valoreRapportoProva);
      this.formUpdate.controls['valoreArrotondato'].setValue(dati?.valoreArrotondato);
      this.formUpdate.controls['incertezza'].setValue( dati?.incertezza );
      this.formUpdate.controls['metodo'].setValue(dati?.metodo);
      this.formUpdate.controls['valoreLfs'].setValue(dati?.valoreLfs);
      this.formUpdate.controls['valoreLoq'].setValue( dati?.valoreLoq );
      this.formUpdate.controls['loq'].setValue(dati?.loq);
      this.formUpdate.controls['lfs'].setValue(dati?.lfs);
      this.item=dati?.parametro

    }
  }
  checkFormValidity() {

    this.errorMessage = [''];
    for (const control in this.formGeneric?.controls) {
      if (this.formGeneric.controls.hasOwnProperty(control)) {
        const formControl = this.formGeneric.get(control);
   
        if (formControl && formControl.invalid) {
          
          var datoErroreDettaglio = control.trim();
          if (datoErroreDettaglio == 'prelievo') {
            const formGroup = this.formGeneric.get('prelievo') as FormGroup;
            for (const prelievoControl in formGroup?.controls) {
              if (formGroup.controls.hasOwnProperty(prelievoControl)) {
                const prelievoFormControl = formGroup.get(prelievoControl);
                if (prelievoFormControl && prelievoFormControl.invalid) {
                  var errorPrelievo = prelievoControl.trim();
                  if (errorPrelievo = 'dataOraPrelievo') {
                    this.errorMessage.push(`La data di ora prelievo deve essere compresa tra la data di inizio validità e la data di fine validità del punto di campionamento associato al controllo`);
                  } else {
                    this.errorMessage.push(`${errorPrelievo} non ha un valore corretto`);
                  }
                }
              }
            }
          } else if (datoErroreDettaglio == 'analisi') {
            const formGroup = this.formGeneric.get('analisi') as FormGroup;
            for (const analisiControl in formGroup?.controls) {
              if (formGroup.controls.hasOwnProperty(analisiControl)) {
                const analisiFormControl = formGroup.get(analisiControl);
                if (analisiFormControl && analisiFormControl.invalid) {
                  var errorAnalisi = analisiControl.trim();
                  if (errorAnalisi == 'dataOraAnalisi') {
                    this.errorMessage.push(`La data di ora analisi deve essere maggiore o uguale alla data settata in dataOraPrelievo e minore della data di fine validità del punto di campionamento associato al controllo`);
                  } else {
                    this.errorMessage.push(`${errorAnalisi} non ha un valore corretto`)
                  }
                }
              }
            }
          }
          else {
            this.errorMessage.push(`${datoErroreDettaglio} non ha un valore corretto`)
          }
        }
      }
    }

    this.cdr.detectChanges();
  }

  showDialog(): void {
    const dialogRef = this.dialogService.open(MyDialogComponent, {
      data: {
        title:"Errori",
        message:this.errorMessage
      },
    
    });

    dialogRef.afterClosed().subscribe(() => {

    });
  }
  showDialogParametriInsert(): void {
  
    const dialogRef = this.dialogService.open(MyDialogComponentInsertParametri, {
      data: {
        title:"Aggiungi Dato Prelievo",
        parametroInsert:this.model().parametriDisponibili,
        idControllo:this.id
      },
    
    });

    dialogRef.afterClosed().subscribe((e) => {

      if (e != undefined && e!= 'undefined') {
           this.reload.emit()
      }
 
     
    });
  }
  checkModelGeneric(dataGeneric:any){
    if(dataGeneric){
      this.formGeneric.addControl("id", new FormControl(this.id ))
      this.formGeneric.addControl("controlloEsterno",new FormControl(false) )
      this.formGeneric.addControl("controlloExtraPiano",new FormControl(false) )
      this.formGeneric.addControl("prelievo",this.fb.group<IPrelievoModify>({
        dataOraPrelievo:dataGeneric?.prelievo.dataOraPrelievo,
        codicePrelievo: dataGeneric?.prelievo.codicePrelievo,
        entePrelievo: dataGeneric?.prelievo.entePrelievo,
        controlloEsterno: dataGeneric?.prelievo.controlloEsterno,
        controlloExtraPiano: dataGeneric?.prelievo.controlloExtraPiano,

      }))
      this.formGeneric.addControl("analisi",this.fb.group<IAnalisiModify>({
        numeroRapportoProvaAnalisi: dataGeneric?.analisi.numeroRapportoProvaAnalisi,
        dataOraAnalisi: dataGeneric?.analisi.dataOraAnalisi,
        codiceAccrediaLaboratorioAnalisi: dataGeneric?.analisi.codiceAccrediaLaboratorioAnalisi,

      })) 
      this.checkFormValidity();
      this.cdr.detectChanges();
    }

  } 
  get prelievoControl(): FormGroup {
    return this.formGeneric.get('prelievo') as FormGroup;
  }
  get analisiControl(): FormGroup {
    return this.formGeneric.get('analisi') as FormGroup;
  }
  setValueParametroLoq(element:any){

    if(element.get("valoreLoq").value=='<'){
        this.formUpdate.get('valoreRapportoProva')?.setValue(null)
    }
    else if(element.get("valoreLoq").value==''){
      this.formUpdate.get('valoreLoq')?.setValue(null)
      this.formUpdate.get('loq')?.setValue(null)
    }
  }
  setValueParametroLfs(element:any){
    if(element.get("valoreLfs").value=='>'){
      this.formUpdate.get('valoreRapportoProva')?.setValue(null)
    }
    else if(element.get("valoreLfs").value==''){
      this.formUpdate.get('valoreLfs')?.setValue(null)
      this.formUpdate.get('lfs')?.setValue(null)
    }
  }
  toFormGroup(control: any) {

    this.setValueParametroLoq(control)
    this.setValueParametroLfs(control)

  }
  isURLEncoded(str:any) {
    try {
      decodeURIComponent(str);
    } catch (error) {
      return false;
    }
    return true;
  }
   getStatusIcon(status: any): string {
    let icon = this.statusDefaultIcon[status];
    let textColor = this.statusDefaultTextColor[status];
    return `<mat-icon matTooltip="${status}" class="mat-mdc-tooltip-trigger ${textColor} material-symbols-outlined">${icon}</mat-icon>`;
  }
  notSUbmit(e:any){
    e.preventDefault()
  }

  costumSaveFuction(el:any, crud:any){

  const dati={
    id:el.controls['id'].value,
    parametroId:el.controls['parametroId'].value,
    valoreRapportoProva:el.controls['valoreRapportoProva'].value,
    valoreArrotondato:el.controls['valoreArrotondato'].value,
    incertezza:el.controls['incertezza'].value,
    metodo:el.controls['metodo'].value,
    valoreLfs:el.controls['valoreLfs'].value,
    valoreLoq:el.controls['valoreLoq'].value,
    loq:el.controls['loq'].value,
    lfs:el.controls['lfs'].value,
  }

  crud.editValControlli(dati)
    .subscribe((data: any) => {
      this.dialogService.success('Dato salvati correttamente', false);
      this.reload.emit()
    })
  
  }

  
}
